if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {
      constructor() {
	super();

	const qty = this.querySelector('.qty-selector'),
				qtyMinus = this.querySelector('.qty-minus'),
				qtyPlus = this.querySelector('.qty-plus');

let productId = null;

// Se siamo nella pagina prodotto, prendi il data-id
const productPage = this.closest('product-page');
if (productPage) {
    productId = parseInt(productPage.getAttribute('data-id'));
} else {
    // Altrimenti, siamo nel carrello, prendi il data-product-id
    const cartItem = this.closest('[data-js-cart-item]');
    if (cartItem) {
        productId = parseInt(cartItem.getAttribute('data-product-id'));
    }
}

/*
// Verifica se abbiamo ottenuto un ID valido
if (productId) {
    console.log('Product ID:', productId);
} else {
    console.log('Product ID non trovato');
}
*/

	// Lista dei prodotti con minimo 3 pezzi	
	// 14843863531845 = Apollo 250gr (macinato)	
	// 14843861172549 = Efesto 250gr (macinato)
	// 14843869036869 = Afrodite 250gr (macinato)	
	// 14843867693381 = Zeus 250gr (macinato)	
	// 14843866218821 = Hermes 250gr (macinato)
	// 14843864285509 = Ares 250gr (macinato)

	// 14843774239045 = Efesto 250gr (grani)
	// 14843774796101 = Apollo 250gr (grani)
	// 14843774501189 = Ares 250gr (grani)
	// 14843773911365 = Hermes 250gr (grani)
	// 14843773124933 = Zeus 250gr (grani)
	// 14843775058245 = Afrodite 250gr (grani)	

	// 14839291674949 = Bevanda nocciola
	// 14839299932485 = Bevanda ginseng
	// 14839292920133 = Bevanda cappuccino
	// 14840998003013 = Bevanda miniciok
	// 14839293280581 = Bevanda tè al limone

	// 15170442789189 = Monorigine

	// const specialProducts = [14839291674949, 14839299932485, 14839292920133, 14840998003013, 14839293280581, 15170442789189, 14843863531845, 14843861172549, 14843869036869, 14843867693381, 14843866218821, 14843864285509, 14843774239045, 14843774796101, 14843774501189, 14843773911365, 14843773124933, 14843775058245];

	let qtyMin = 1;
    /*
	if (specialProducts.includes(productId)) {
      qtyMin = 3;
    } 
    */  

	const qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;

	// Imposta valore iniziale se sotto il minimo
	if (parseInt(qty.value) < qtyMin) {
		qty.value = qtyMin;
	}

	const updateButtons = () => {
		const currentQty = parseInt(qty.value);
		qtyMinus.classList.toggle('disabled', currentQty <= qtyMin);
		qtyPlus.classList.toggle('disabled', currentQty >= qtyMax);
	};

	updateButtons();

	qty.addEventListener('change', () => {
		if (parseInt(qty.value) < qtyMin) {
			qty.value = qtyMin;
		}
		updateButtons();
	});

	qtyMinus.addEventListener('click', (e) => {
		e.preventDefault();
		const currentQty = parseInt(qty.value);
		if (currentQty > qtyMin) {
			qty.value = currentQty - 1;
			updateButtons();
		}
	});

	qtyPlus.addEventListener('click', (e) => {
		e.preventDefault();
		const currentQty = parseInt(qty.value);
		if (currentQty < qtyMax) {
			qty.value = currentQty + 1;
			updateButtons();
		}
	});
}


		
	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}